import React from 'react';
import * as Styles from './IconCrown.styles';

const IconCrown = ({ size }) => {
  const sizes = {
    small: 16,
    medium: 20,
    large: 28,
  };
  const width = sizes[size] || sizes.medium;
  const height = width * 0.7;

  return (
    <Styles.Svg width={width} height={height} viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="IconCrown">
      <path d="M13.8013 7.68995L9.6608 0.783203L5.52031 7.68995L0 2.16441L1.38016 13.2155H17.9414L19.3216 2.16441L13.8013 7.68995Z" fill="#F3F9FF" />
    </Styles.Svg>

  );
};

export default IconCrown;
